<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>培训中心</span><span>/</span><span>企业题库</span></div>
    <div class="disFlex curse-search">
      <div>
        <el-input v-model="formInline.keyword" placeholder="请输入名称查询" suffix-icon="el-icon-search" clearable></el-input>
      </div>
    </div>
    <div style="background-color: #fff;min-height: 50vh;">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="el-menu-item" @click="handleNodeClick({uniqueCode:''})"><i
              class="el-icon-menu"></i><span>全部类型</span></div>
          <!-- :default-openeds="['ZXKT_producttype_2','ZXKT_producttype_3']"  -->
          <el-menu class="el-menu-vertical-demo">
            <el-submenu v-for="(item,i) in options" :index="item.uniqueCode" :key="item.uniqueCode">
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{item.text}}</span>
              </template>
              <el-menu-item @click="handleNodeClick(child)" v-for="(child,j) in item.children" :index="child.id"
                :key="child.id">{{child.text}}</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
        <el-col :span="20" style="border-left: 1px solid #e6e6e6;min-height: 50vh;">
          <div v-loading="loading">
            <div v-if="tableData.rows.length>0">
              <div @click="toDetail(item.id)" class="disFlexAllKc" style="justify-content: space-between;"
                v-for="(item,k) in tableData.rows">
                <div>
                  <div class="kcCname">{{item.cname}}
                    <el-tag style="margin-left: 15px;">{{item.ontypeName}}</el-tag>
                  </div>
                  <div>课时：{{item.ksyq||item.ks}}课时
                    <span style="padding: 0 20px;">有效期：{{item.endtime}}</span>
                  </div>
                </div>
                <div>
                  <div class="toLianxi">
                    练习题
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>

            <div v-else style="height: 200px;background-color: #fff;text-align: center;">
              <img style="margin: 70px 0 20px;" src="@/assets/images/nodata.png" />
              <div style="font-size: 18px;color: #999999;">暂无数据</div>
            </div>
          </div>

          <el-pagination background :hide-on-single-page="true" style="margin-top: 10px;text-align: right;"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.page"
            :page-sizes="[10, 20, 50, 100]" :page-size="formInline.rows"
            layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
          </el-pagination>
        </el-col>
      </el-row>

    </div>


  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    props: ['collapse', 'wjSrc', 'zyjnList', 'zyzclist', 'currentUser'],
    data() {
      return {
        formInline: {
          keyword: '',
          page: 1,
          rows: 10,
          flag: '1',
          cid: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [],
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        loading: true
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        var params = this.formInline;
        this.$axios.get('/kt/productInfo/get2listPage.htm?' + this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toDetail: function(id) {
        this.$router.push('/testQuestion?id=' + id);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      // 跳转产品详情
      toProductXq: function(id) {
        this.$router.push('/ProductDetail?id=' + id);
      },
      handleNodeClick(data) {
        this.$set(this.formInline, 'ontype', data.uniqueCode);
      }
    },
    created: function() {
      getItype(this.$axios,((res)=>{
        this.options=res;
      }));
      this.$set(this.formInline, 'cid', this.currentUser.cid);
    },
    components: {
      BaomingList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1)
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .el-menu {
    border-right: 0;
  }

  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .disFlexAllKc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background-color: #fff;
    margin: 10px 10px 10px 0;
    border-radius: 10px;
    font-size: 14px;
    border: 1px solid #efefef;
    transition: all 0.3s linear;
    cursor: pointer;
  }

  .disFlexAllKc:hover {
    border: 1px solid #0071ba;
    box-shadow: 0px 2px 4px 0px rgba(0, 113, 186, 0.26);
  }

  .disFlexAllKc .kcCname {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    height: 30px;
  }

  .disFlexAllKc .toLianxi {
    cursor: pointer;
    color: #0071ba;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Enterprise.vue